import type { PositionValue } from '@elfsight/configurator-contracts';

export function positionMixin(_position: PositionValue) {
  return basePositionMixin(positionRelativeOptions[_position]);
}

type Position = 0 | 'auto' | '50%';

const basePositionMixin =
  ({
    top = 'auto',
    left = 'auto',
    right = 'auto',
    bottom = 'auto'
  }: {
    top?: Position;
    left?: Position;
    right?: Position;
    bottom?: Position;
  }) =>
  () => {
    return `
      top: ${top};
      left: ${left};
      right: ${right};
      bottom: ${bottom};
    `;
  };

const positionRelativeOptions = {
  'top-left': { top: 0, left: 0 },
  top: { top: 0, right: '50%' },
  'top-right': { top: 0, right: 0 },
  right: { right: 0, bottom: '50%' },
  'bottom-right': { right: 0, bottom: 0 },
  bottom: { right: '50%', bottom: 0 },
  'bottom-left': { bottom: 0, left: 0 },
  left: { bottom: '50%', left: 0 }
} as Record<PositionValue, Record<PositionValue, Position>>;
